import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { handleApiErrors } from '../../../lib/api-errors';
import {
  ASSOCIATE_REQUESTING,
  CDKT_REQUESTING,
  COLLECTION_PRICE_REQUESTING,
  COMPANY_INFO_REQUESTING,
  CST_REQUESTING,
  KQKD_REQUESTING,
  NEWS_DETAIL_REQUESTING,
  STOCK_DETAIL_REQUESTING,
  STOCK_EVENTS_REQUESTING,
  STOCK_HIS_REQUESTING,
  STOCK_MANAGEMENT_REQUESTING,
  STOCK_NEWS_REQUESTING,
  STOCK_TRADE_REQUESTING,
  TRANSFER_DATA_REQUESTING,
} from './constants';

import { getConfig } from '../../../lib/selector';
import { _processMapDataCS } from '../../../utils';
import {
  associateRequestError,
  associateRequestSuccess,
  cdktRequestError,
  cdktRequestSuccess,
  collectionPriceRequestError,
  collectionPriceRequestSuccess,
  companyInfoRequestError,
  companyInfoRequestSuccess,
  cstRequestError,
  cstRequestSuccess,
  kqkdRequestError,
  kqkdRequestSuccess,
  newsDetailRequestError,
  newsDetailRequestSuccess,
  stockDetailRequestError,
  stockDetailRequestSuccess,
  stockEventsRequestError,
  stockEventsRequestSuccess,
  stockHisRequestSuccess,
  stockManagementRequestError,
  stockManagementRequestSuccess,
  stockNewsRequestError,
  stockNewsRequestSuccess,
  stockTradeRequestError,
  stockTradeRequestSuccess,
  transferDataRequestError,
  transferDataRequestSuccess,
} from './actions';

const infoUrl = `${process.env.REACT_APP_INFO_URL}`;
let priceUrl; // = `${process.env.REACT_APP_PRICE_URL}`;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function stockDetailRequestApi(data) {
  const url = `${priceUrl}/getliststockdata/${data.toUpperCase()}`;
  const request = fetch(url);

  return handleRequest(request);
}

function stockTradeRequestApi(data) {
  const url = `${priceUrl}/getliststocktrade/${data.toUpperCase()}`;
  const request = fetch(url);

  return handleRequest(request);
}

function reportRequestApi(data) {
  const url = `https://info.sbsi.vn/stockReport.pt?${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function reportHisRequestApi(data) {
  const url = `${infoUrl}/getPriceHistory/${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function transferDataRequestApi(data) {
  const url = `${infoUrl}/transferData.pt?${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function reportNewsRequestApi(data) {
  const url = `https://info.sbsi.vn/stockNews.pt?symbol=${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function newsDetailRequestApi(data) {
  const url = `https://info.sbsi.vn/newsDetail.pt?id=${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function stockEventsRequestApi(data) {
  const url = `https://info.sbsi.vn/stockEvents.pt?${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function stockManageRequestApi(data) {
  const url = `https://info.sbsi.vn/stockMangement.pt?symbol=${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function companyInfoRequestApi(data) {
  const url = `https://info.sbsi.vn/companyInfo.pt?symbol=${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function associateRequestApi(data) {
  const url = `https://info.sbsi.vn/associate.pt?symbol=${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function collectionPriceRequestApi(data) {
  const url = `${infoUrl}/getPriceAllocation/${data}`;
  const request = fetch(url);
  return handleRequest(request);
}

function* stockDetailRequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    // call to our snapshotRequestApi function with the client
    const dataList = yield call(stockDetailRequestApi, data);

    let symbol;
    if (dataList && !!dataList.length) {
      symbol = _processMapDataCS(dataList[0]);
    }

    // dispatch the action with our symbol!
    yield put(stockDetailRequestSuccess(symbol));
  } catch (error) {
    yield put(stockDetailRequestError(error));
  }
}

function* stockTradeRequestFlow({ data }) {
  try {
    const config = yield select(getConfig);
    if (!priceUrl) {
      priceUrl = config.config.bs;
    }
    // call to our snapshotRequestApi function with the client
    const dataList = yield call(stockTradeRequestApi, data);

    // dispatch the action with our symbol!
    yield put(stockTradeRequestSuccess(dataList));
  } catch (error) {
    yield put(stockTradeRequestError(error));
  }
}

function* cstRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(reportRequestApi, data);

    yield put(cstRequestSuccess(dataList));
  } catch (error) {
    yield put(cstRequestError(error));
  }
}

function* kqkdRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(reportRequestApi, data);

    yield put(kqkdRequestSuccess(dataList));
  } catch (error) {
    yield put(kqkdRequestError(error));
  }
}

function* cdktRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(reportRequestApi, data);

    yield put(cdktRequestSuccess(dataList));
  } catch (error) {
    yield put(cdktRequestError(error));
  }
}

function* stockHisRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(reportHisRequestApi, data);

    yield put(stockHisRequestSuccess(dataList));
  } catch (error) {
    yield put(stockTradeRequestError(error));
  }
}

function* transferDataRequestFlow(action) {
  try {
    const { data } = action;
    const dataList = yield call(transferDataRequestApi, data);

    yield put(transferDataRequestSuccess(dataList));
  } catch (error) {
    yield put(transferDataRequestError(error));
  }
}

function* stockNewsRequestFlow(action) {
  try {
    const { data } = action;
    const news = yield call(reportNewsRequestApi, data);

    yield put(stockNewsRequestSuccess(news));
  } catch (error) {
    yield put(stockNewsRequestError(error));
  }
}

function* newsDetailRequestFlow(action) {
  try {
    const { data } = action;
    const newsDetail = yield call(newsDetailRequestApi, data);

    yield put(newsDetailRequestSuccess(newsDetail));
  } catch (error) {
    yield put(newsDetailRequestError(error));
  }
}

function* stockEventsRequestFlow(action) {
  try {
    const { data } = action;
    const events = yield call(stockEventsRequestApi, data);

    yield put(stockEventsRequestSuccess(events));
  } catch (error) {
    yield put(stockEventsRequestError(error));
  }
}

function* stockManageRequestFlow(action) {
  try {
    const { data } = action;
    const events = yield call(stockManageRequestApi, data);

    yield put(stockManagementRequestSuccess(events));
  } catch (error) {
    yield put(stockManagementRequestError(error));
  }
}

function* companyInfoRequestFlow(action) {
  try {
    const { data } = action;
    const events = yield call(companyInfoRequestApi, data);

    yield put(companyInfoRequestSuccess(events));
  } catch (error) {
    yield put(companyInfoRequestError(error));
  }
}

function* associateRequestFlow(action) {
  try {
    const { data } = action;
    const associate = yield call(associateRequestApi, data);

    yield put(associateRequestSuccess(associate));
  } catch (error) {
    yield put(associateRequestError(error));
  }
}

function* collectionPriceRequestFlow(action) {
  try {
    const { data } = action;
    // console.log(data)
    const associate = yield call(collectionPriceRequestApi, data);
    // console.log(associate)
    yield put(collectionPriceRequestSuccess(associate));
  } catch (error) {
    yield put(collectionPriceRequestError(error));
  }
}

function* stockDetailWatcher() {
  yield all([
    takeLatest(STOCK_DETAIL_REQUESTING, stockDetailRequestFlow),
    takeLatest(STOCK_TRADE_REQUESTING, stockTradeRequestFlow),
    takeLatest(CST_REQUESTING, cstRequestFlow),
    takeLatest(KQKD_REQUESTING, kqkdRequestFlow),
    takeLatest(CDKT_REQUESTING, cdktRequestFlow),
    takeLatest(STOCK_HIS_REQUESTING, stockHisRequestFlow),
    takeLatest(STOCK_NEWS_REQUESTING, stockNewsRequestFlow),
    takeLatest(NEWS_DETAIL_REQUESTING, newsDetailRequestFlow),
    takeLatest(STOCK_EVENTS_REQUESTING, stockEventsRequestFlow),
    takeLatest(STOCK_MANAGEMENT_REQUESTING, stockManageRequestFlow),
    takeLatest(COMPANY_INFO_REQUESTING, companyInfoRequestFlow),
    takeLatest(ASSOCIATE_REQUESTING, associateRequestFlow),
    takeLatest(TRANSFER_DATA_REQUESTING, transferDataRequestFlow),
    takeLatest(COLLECTION_PRICE_REQUESTING, collectionPriceRequestFlow),
  ]);
}

export default stockDetailWatcher;
